import React, { PropsWithChildren, useEffect } from 'react';

import {
  trackLoadingTime,
  TRACKING_ACTIONS,
  TOTAL_REMOTE_LOADING_TIME,
} from '@adsk/exo-skeleton-api';

interface RemoteLoaderWrapperProps {
  scope: string;
  moduleName: string;
}

const REMOTE_ENTRY_FILE_LOADING_TIME_ID = 'remote-entry-loading';

export const RemoteLoaderWrapper: React.FC<
  PropsWithChildren<RemoteLoaderWrapperProps>
> = ({ scope, moduleName, children }) => {
  useEffect(() => {
    void trackLoadingTime({
      scope,
      moduleName,
      action: TRACKING_ACTIONS.START,
      trackingId: REMOTE_ENTRY_FILE_LOADING_TIME_ID,
      parentTrackingId: TOTAL_REMOTE_LOADING_TIME,
    });

    return () => {
      void trackLoadingTime({
        scope,
        moduleName,
        action: TRACKING_ACTIONS.END,
        trackingId: REMOTE_ENTRY_FILE_LOADING_TIME_ID,
        parentTrackingId: TOTAL_REMOTE_LOADING_TIME,
      });
    };
  }, [scope, moduleName]);

  return <>{children}</>;
};
